export default __webpack_public_path__ + "static/media/baby-38.075e857a.svg";